import { render, staticRenderFns } from "./ZammadList.vue?vue&type=template&id=026c7dd0"
import script from "./ZammadList.vue?vue&type=script&lang=ts"
export * from "./ZammadList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports